// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2y3Di","additionalInfo":"AgreementModal_additionalInfo__19AnN"};